var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer",attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"bar","height":"250","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }